import React, { useContext } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../components/Pagination'
import { Context } from '../MoneyLogHistory'

function formatBalance(value) {
  if (value === null || value === undefined || value === '') {
    return '0'
  }
  return new Intl.NumberFormat('vn-VI', {}).format(value)
}

function displayPhone(phone) {
  if (!phone) {
    return ''
  }
  return phone.replace('+84', '0')
}

const _Table = () => {
  const { state, dispatch } = useContext(Context);
  const user = state.data.user

  return (
    <Card border="light" className="shadow-sm">
      {user ? (
        <Card.Header>
          <div><strong>{user.name}</strong> <span className="text-primary">{displayPhone(user.phone)}</span></div>
          <div className="small">
            {state.filter.wallet === 'reward' ? 'Ví thưởng' : 'Ví chính'}: {formatBalance(state.filter.wallet === 'reward' ? user.rewardAmount : user.amount)} VND · {state.data.total} dòng
          </div>
        </Card.Header>
      ) : null}
      <Table responsive className="align-items-center table-bordered table-hover">
        <thead className='text-center'>
          <tr>
            <th scope="col">Thời gian</th>
            <th scope="col">Loại</th>
            <th scope="col">Số tiền</th>
            <th scope="col">Mã tham chiếu</th>
            <th scope="col">Mô tả</th>
          </tr>
        </thead>
        <tbody>
          {state.data.list && state.data.list.length > 0 ? state.data.list.map((item) => (
            <TableRow key={`${item.wallet}-${item.id}`} {...item} />
          )) : (
            <tr>
              <td colSpan={5} className="text-center">
                {state.data.message
                  || (state.filterPressCount === 0
                    ? 'Nhập số điện thoại và khoảng ngày để xem lịch sử của một người'
                    : 'Không có dòng tiền trong khoảng ngày này')}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Card.Footer className='flex-row'>
        <Row className="align-items-center">
          <Col>
            <Pagination
              totalPage={state.data.totalPage || 0}
              currentPage={state.filter.page || 0}
              onPageChange={(i) => {
                dispatch({
                  type: 'UPDATE_PAGE',
                  payload: i
                })
              }}
            />
          </Col>
        </Row>
      </Card.Footer>
    </Card>
  );
};

export default React.memo(_Table)
